import { useState } from "react";

import { Button, ButtonIconWithLabel, Icon_OpenNew24, Link } from "@shapr3d/frontend-lib";

import { CollaborationPromoURL } from "../../config";
import { useTracker } from "../../hooks/useTracker";
import { ElementClickAction, ElementClickLocation } from "../../lib/TrackingAdapter";
import { PublishVersionModal } from "./components/PublishVersionModal";

import style from "./PublishVersionPromo.module.css";

export const PublishVersionPromo = () => {
  const tracker = useTracker();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className={style.container}>
      <div className={style.content}>
        <div className={style.title}>Publish your first version</div>
        <div className={style.description}>
          Open the Shapr3D app to publish the current version of this project.
        </div>
        <div className={style.actions}>
          <Button
            onClick={() => {
              setIsModalOpen(true);
            }}
          >
            <ButtonIconWithLabel icon={<Icon_OpenNew24 />} label="Publish Current Version..." />
          </Button>
          <Link
            href={CollaborationPromoURL}
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              tracker.trackButtonClick({
                action: ElementClickAction.LEARN_MORE_PUBLISHING_VERSIONS,
                location: ElementClickLocation.PROJECT_PAGE,
              });
            }}
          >
            Learn more about publishing versions...
          </Link>
        </div>
      </div>
      <PublishVersionModal open={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
};
